import React from 'react'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { CCard, CCardHeader, CCol, CRow } from '@coreui/react-pro'
import Error from 'components/Error'
import Loading from 'components/Loading'
import ReportForm from 'components/Report/ReportForm'

async function getData({ queryKey }) {
  const [key, id] = queryKey

  const response = await axios({
    method: 'GET',
    url: `/report-cards/${id}`,
  })

  return response.data
}

function ReportEdit() {
  const { id } = useParams()
  const { isError, isSuccess, isLoading, data } = useQuery(['report', id], getData, { staleTime: 60000 })
  const navigate = useNavigate()

  if (isSuccess && !data?.report_id) {
    navigate('/not-found')
  }

  return (
    <CRow>
      <CCol xs={12}>
        <CCard>
          <CCardHeader>
            <strong>Formulário</strong> <small>Edição</small>
          </CCardHeader>
          {isLoading && <Loading />}
          {isError && <Error className="m-3" />}
          {isSuccess && <ReportForm report={{ ...data, id }} />}
        </CCard>
      </CCol>
    </CRow>
  )
}

export default ReportEdit
